import { CircleButton } from 'pages/Shifts/Shifts.styled'
import { Flex } from 'styling/GlobalStyles'
import { SquareCheckBox } from './CheckBox.styled'
import { BodyText } from 'styling/Typography'

export const CheckBox = ({
  state,
  onClick,
  title,
  square
}: {
  state: boolean
  onClick?: () => void
  title: string
  square?: boolean
}) => {
  return (
    <Flex center gap='1rem' width='100%' height='1.5rem' onClick={onClick}>
      {square ? <SquareCheckBox active={state} /> : <CircleButton checked={state} />}
      <BodyText>{title}</BodyText>
    </Flex>
  )
}
